import { gql } from '@apollo/client';

export const commodityPackageFragments = {
  commodityPackageItem: gql`
    fragment CommodityPackageItem on PackageCommodity {
      id
      projectId
      packageId
      commodityId
      assignedDate
      asBuiltDate
      updatedTime
      updatedBy
    }
  `,
};
export const SAVE_COMMODITY_PACKAGES = gql`
  ${commodityPackageFragments.commodityPackageItem}
  mutation saveCommodityPackages($saveCommodityPackagesInput: SaveCommodityPackagesInput!) {
    saveCommodityPackages(saveCommodityPackagesInput: $saveCommodityPackagesInput) {
      errors
      commodityPackages {
        ...CommodityPackageItem
        package {
          tag
          status
          type
        }
      }
    }
  }
`;

export const GET_PACKAGES_BY_COMMODITY = gql`
  ${commodityPackageFragments.commodityPackageItem}
  query PackagesByCommodity($commodityId: ID!, $packageCommodityType: PackageCommodityType!) {
    packagesByCommodity(commodityId: $commodityId, packageCommodityType: $packageCommodityType) {
      ...CommodityPackageItem
      package {
        id
        tag
        status
        type
      }
    }
  }
`;

export const GET_PACKAGE_COMMODITIES = gql`
  ${commodityPackageFragments.commodityPackageItem}
  query PackageCommodities($packageId: ID!, $packageCommodityType: PackageCommodityType!) {
    commoditiesByPackage(packageId: $packageId, packageCommodityType: $packageCommodityType) {
      ...CommodityPackageItem
      commType
      cableView {
        fromEquipmentTag
        toEquipmentTag
      }
      commodity {
        ... on Cable {
          id
          tag
        }
        ... on Equipment {
          id
          tag
        }

        ... on Raceway {
          id
          tag
        }

        ... on Jumper {
          id
          tag
        }
      }
    }
  }
`;

export const SAVE_PACKAGE_COMMODITIES = gql`
  ${commodityPackageFragments.commodityPackageItem}
  mutation SavePackageCommodities($savePackageCommoditiesInput: SavePackageCommoditiesInput!) {
    savePackageCommodities(savePackageCommoditiesInput: $savePackageCommoditiesInput) {
      errors
      commodityPackages {
        ...CommodityPackageItem
        commType
        cableView {
          fromEquipmentTag
          toEquipmentTag
        }
        commodity {
          ... on Cable {
            tag
          }
          ... on Equipment {
            tag
          }

          ... on Raceway {
            tag
          }

          ... on Jumper {
            tag
          }
        }
      }
    }
  }
`;
